//React
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ResizableBox } from 'react-resizable';
//API
import { GcodeApi } from '../../apis/index.js';
//Material-UI
import { TextField } from '@material-ui/core';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
//Components
import MyCircularProgress from '../../components/Circleprogess.js';
//lodash
import { throttle } from 'lodash';

const Gcode = (props) => {
  const [gcodes, setGcodes] = useState([]);
  const [search, setSearch] = useState(false);
  const [searchEnd, setSearchEnd] = useState(true);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  const [searchForHospitalName, setSearchForHospitalName] = useState('');
  const [searchForPatientCode, setSearchForPatientCode] = useState('');
  const [startDate, setStartDate] = useState(
    new Date().setMonth(new Date().getMonth() - 1),
  );
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    firstLoad();
  }, []);

  useEffect(() => {
    if (searchEnd) {
      if (count >= 1 && !search) {
        loadData();
      }
      if (count >= 1 && search) {
        loadSearchData();
      }
    }
  }, [count]);

  // 공통 데이터 로드 함수
  const loadDataCommon = async (
    isSearch,
    hospitalName,
    patientCode,
    pageCount = 0,
  ) => {
    setLoading(false);

    const res = isSearch
      ? await GcodeApi.getSearchGcodeList(
          pageCount,
          patientCode,
          endDate,
          hospitalName,
          startDate,
        )
      : await GcodeApi.getGcodeList(pageCount);

    const transformedData = res.data.content.map((gcode) => ({
      data1: { key: 'ID', value: gcode.id },
      data2: { key: 'Status', value: gcode.gcode_group_status },
      data3: { key: 'Hospital Name', value: gcode.name },
      data4: { key: 'Patient Code', value: gcode.code },
      data5: { key: 'Modify Date', value: gcode.modify_date },
    }));
    setGcodes((prev) =>
      pageCount === 0 ? transformedData : [...prev, ...transformedData],
    );

    if (res.data.numberOfElements !== 15) {
      setSearchEnd(false);
    }

    setLoading(true);
  };

  // 첫 로드
  const firstLoad = async () => {
    await loadDataCommon(false);
  };

  // 추가 데이터 로드
  const loadData = async () => {
    await loadDataCommon(false, null, null, count);
  };

  // 첫 번째 검색 로드
  const loadFirstSearchData = async () => {
    setCount(0);
    setGcodes([]);
    setSearch(true);
    await loadDataCommon(true, searchForHospitalName, searchForPatientCode, 0);
  };

  // 추가 검색 로드
  const loadSearchData = async () => {
    setSearch(true);
    await loadDataCommon(
      true,
      searchForHospitalName,
      searchForPatientCode,
      count,
    );
  };

  const handleSearch = () => {
    setCount(0);
    setSearchEnd(true);
    setGcodes([]);
    setSearch(true);
    loadFirstSearchData();
    scrollToTop();
  };

  const loadMoreItems = () => {
    setCount((prevCount) => prevCount + 1);
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const scrollHeight = document.documentElement.scrollHeight;
    const isAtBottom = scrollTop + windowHeight >= scrollHeight - 34;

    if (isAtBottom) {
      loadMoreItems();
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', throttle(handleScroll, 1000));
    return () =>
      window.removeEventListener('scroll', throttle(handleScroll, 1000));
  }, []);

  // 검색 초기화
  const onClear = () => {
    setCount(0);
    setSearchEnd(true);
    setSearch(false);
    setStartDate(new Date().setMonth(new Date().getMonth() - 1));
    setEndDate(new Date());
    setSearchForHospitalName('');
    setSearchForPatientCode('');
    firstLoad();
    scrollToTop();
  };

  useEffect(() => {
    window.addEventListener('scroll', throttle(handleScroll, 1000));
    return () =>
      window.removeEventListener('scroll', throttle(handleScroll, 1000));
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleRowSelection = (id) => {
    window.open('/updateRegen/' + id);
  };

  //너비 설정
  const column = [
    { key: 'ID', value: 'ID', width: '100' },
    { key: 'Status', value: 'Status', width: '120' },
    { key: 'Hospital Name', value: 'Hospital Name', width: '270' },
    { key: 'Patient Code', value: 'Patient Code', width: '220' },
    { key: 'Modify Date', value: 'Modify Date', width: '250' },
  ];

  const [columnWidths, setColumnWidths] = useState(
    column.map((col) => parseInt(col.width, 10)),
  );

  const handleResize = (index, event, { size }) => {
    setColumnWidths((prevWidths) => {
      const newWidths = [...prevWidths];
      newWidths[index] = size.width;
      return newWidths;
    });
  };

  const totalWidth = columnWidths.reduce((acc, width) => acc + width, 0);
  const remainingWidth = 1150 - totalWidth;

  return (
    <>
      <div className="fixed-header">
        <div className="header-row">
          <div className="title">REGEN FILE LIST</div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            flexWrap: 'wrap',
          }}
        >
          <h6 style={{ marginRight: 20 }}>Date : </h6>
          <div style={{ display: 'flex' }}>
            <div style={{ width: 'fit-content' }}>
              <DatePicker
                dateFormat="yyyy-MM-dd"
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  if (date > endDate) {
                    setEndDate(date);
                  }
                }}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Start date..."
              />
            </div>
            <h6 style={{ margin: '0 20px' }}>~</h6>
            <div style={{ width: 'fit-content' }}>
              <DatePicker
                style={{ border: 'none' }}
                dateFormat="yyyy-MM-dd"
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                placeholderText="End date..."
              />
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: 10,
            flexWrap: 'wrap',
            // borderBottom: '1px solid rgba(224, 224, 224, 1)',
          }}
        >
          <div style={{ width: '100%' }}>
            <TextField
              id="standard-basic"
              label={'Hospital Name '}
              inputProps={{ min: 0, style: {} }}
              InputLabelProps={{ min: 0, style: {} }}
              onChange={(e) => setSearchForHospitalName(e.target.value)}
              value={searchForHospitalName}
              style={{ paddingBottom: 15, paddingRight: 30, width: '50%' }}
            />
            <TextField
              id="standard-basic"
              label={'Patient Code '}
              inputProps={{ min: 0, style: {} }}
              InputLabelProps={{ min: 0, style: {} }}
              onChange={(e) => setSearchForPatientCode(e.target.value)}
              value={searchForPatientCode}
              style={{ paddingBottom: 15, width: '50%' }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-end',
              maxHeight: 40,
              margin: '5px 0 15px',
            }}
          >
            <button onClick={onClear}>Reset</button>
            <button onClick={handleSearch}>Search</button>
          </div>
        </div>

        <div className="table-header-container" style={{ marginTop: '-20px' }}>
          <div className="table-header">
            {column.map((col, id) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                  key={id}
                >
                  <ResizableBox
                    minConstraints={[100, 0]}
                    maxConstraints={[
                      Math.min(400, remainingWidth + columnWidths[id]),
                      0,
                    ]}
                    width={columnWidths[id]}
                    height={30}
                    axis="x"
                    resizeHandles={['e']}
                    onResize={(e, { size }) => handleResize(id, e, { size })}
                  >
                    <div className="table-header-cell">{col.value}</div>
                  </ResizableBox>
                </div>
              );
            })}
          </div>
        </div>
        <div className="horizontal-line"></div>
      </div>

      <div className="content-container" style={{ marginTop: '40px' }}>
        {gcodes.map((data, id) => {
          return (
            <div key={id}>
              <button
                className="row-button"
                onClick={() => handleRowSelection(data.data1.value)}
              >
                <div className="row-content">
                  {Object.keys(data).map((key, index) => {
                    return (
                      <div
                        className="cell"
                        style={{
                          width: columnWidths[index],
                        }}
                        key={index}
                      >
                        <div className="cell-content">{data[key].value}</div>
                      </div>
                    );
                  })}
                </div>
              </button>
            </div>
          );
        })}
      </div>

      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          marginTop: '60px',
        }}
      >
        {!loading ? <MyCircularProgress /> : <></>}
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: '100px',
          right: '40px',
          width: '30px',
          height: '30px',
          backgroundColor: '#FFFFFF',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ExpandCircleDownIcon
          onClick={scrollToTop}
          style={{
            fontSize: '50px',
            color: '#3F598C',
            transform: 'rotate(180deg)',
          }}
        />
      </div>
    </>
  );
};

export default Gcode;
